import { FC, useRef } from "react";

import { Icons } from '@/components/icons';
import Tooltip from '@/components/tooltip';

import { getIsResetButton } from './utils';


interface NetworkInputProps {
  label: string;
  tooltip?: string;
  value: string;
  defaultValue?: string;
  onChange: (value: string) => void;
  onReset?: () => void;
  showReset?: boolean;
  placeholder?: string;
}

const NetworkInput: FC<NetworkInputProps> = ({
  label,
  tooltip,
  value,
  defaultValue,
  onChange,
  onReset,
  showReset = false,
  placeholder,
}) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const moveCursorToEnd = () => {
    requestAnimationFrame(() => {
      if (inputRef.current) {
        inputRef.current.focus();
        const length = inputRef.current.value.length;
        inputRef.current.setSelectionRange(length, length);
        inputRef.current.scrollLeft = inputRef.current.scrollWidth;
      }
    });
  };

  const isResetButton = getIsResetButton(showReset, value, defaultValue);

  return (
    <div className="flex flex-col gap-3">
      <div className="flex items-center justify-between">
        <h1 className="text-text-secondary text-xl tracking-02em leading-6 gap-1 flex items-center">
          {label}
          {tooltip && (
            <Tooltip iconColor="text-text-secondary">
              <span>{tooltip}</span>
            </Tooltip>
          )}
        </h1>
        {isResetButton && (
          <div className="flex items-center">
            <Icons.refresh />
            <button
              className="text-text-secondary text-sm leading-4 tracking-02em p-1.5"
              onClick={onReset}
            >
              Reset Changes
            </button>
          </div>
        )}
      </div>
      <input
        ref={inputRef}
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onFocus={moveCursorToEnd}
        onClick={moveCursorToEnd}
        placeholder={placeholder}
        className="w-full text-text-primary leading-18 px-4 h-[50px] flex items-center justify-between cursor-pointer bg-surface-secondary z-[100] rounded-lg focus:outline-none placeholder:text-text-secondary"
      />
    </div>
  );
};

export default NetworkInput;
